export function canAccessPyl(user) {
  if (!user) return false;
  if (user.isSuperAdmin === true || user.role === 'admin') return true;
  const slug = (user.currentPlan?.slug || '').toLowerCase();
  if (['profesional', 'empresarial', 'enterprise', 'professional', 'business'].includes(slug)) {
    return true;
  }
  const features = user.unlockedFeatures || user.currentPlan?.features || {};
  return !!(features.flujoDeCaja || features.reportesAutomatizados || features.advancedAnalytics);
}
